export default [
    {
      path: '/cancellations',
      name: 'cancellations',
      component: () => import('@/views/sft/Cancellations.vue'),
    },
  ]